export default [{
  path: 'data-agent',
  name: 'data-agent',
  component: () => import('./agent/index.vue'),
  meta: {
    code: '/stat/agentStat.htm'
  }
}, {
  path: 'data-user',
  name: 'data-user',
  component: () => import('./user/index.vue'),
  meta: {
    code: '/stat/userStat.htm'
  }
}];



// WEBPACK FOOTER //
// ./src/views/data/index.route.js